export default "__VITE_ASSET__BVimGde7__"